/* Syrup Oracle: Bar Book finder v2 — curated-data edition.
   Fetches ALL active bar_book_recipe entries from the dashboard-maintained
   bar-book.json (Shopify Files; regenerated dashboard-side on recipe edits),
   which beats the 50-entry cap on shop.metaobjects in Liquid. Cards missing
   from the Liquid render (entries 51+) are cloned client-side from the first
   rendered card, and the whole grid is re-ordered by the sort field.

   Scoring uses the dashboard's curated facets (SYNC-dashboard-site.md
   addendum 6): sweetness/strength ints 1-5, flavors/serve/category tags,
   granular spirit slugs, pantry tokens. Phrase mappings per the contract:
   tart = sweetness<=2, sweet = >=4, won't-taste-the-alcohol = strength<=2,
   stiff = >=4, zero-proof = strength==1. If the JSON fetch fails, falls back
   to parsing the rendered cards and deriving pseudo-scores from real ounces.

   Progressive enhancement: the finder UI stays hidden without JS. */
(function () {
  'use strict';

  // Bare CDN path on purpose: the dashboard's regeneration keeps the path
  // stable and bumps ?v= — we always want the latest.
  var DATA_URL = 'https://cdn.shopify.com/s/files/1/0018/5715/9281/files/bar-book.json';

  var finder = document.getElementById('soBBFinder');
  var book = document.querySelector('.so-recipe-book');
  if (!finder || !book) return;

  var cfgEl = document.getElementById('so-bb-config');
  if (cfgEl) {
    try { var cfg = JSON.parse(cfgEl.textContent); if (cfg && cfg.data) DATA_URL = cfg.data; } catch (e) {}
  }

  function handleize(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // slug -> friendly label for pantry checkboxes ("lime-juice" -> "Lime juice")
  var PRETTY_SMALL = { of: 1, the: 1, and: 1, with: 1, 'n': 1 };
  var PRETTY_UPPER = { pog: 'POG', bg: 'BG', '151': '151' };
  function prettySlug(slug) {
    return (slug || '').split('-').map(function (w, i) {
      if (PRETTY_UPPER[w]) return PRETTY_UPPER[w];
      if (i > 0 && PRETTY_SMALL[w]) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  /* ---------- fallback: derive pseudo-facets from rendered ounces ---------- */

  var FRACTIONS = { '¼': 0.25, '½': 0.5, '¾': 0.75, '⅓': 0.33, '⅔': 0.67, '⅛': 0.125 };
  var SPIRITS_RE = /rum|gin\b|whisk|bourbon|rye\b|scotch|tequila|mezcal|vodka|brandy|cognac|pisco|absinthe|liqueur|curacao|curaçao|sherry|port\b|amaro|campari|aperol/;
  var SHARP_RE = /lime|lemon|grapefruit/;
  var SWEET_RE = /syrup|orgeat|falernum|demerara|honey|grenadine|fassionola|cordial|molasses|cream of coconut|coconut cream|gardenia|vanilla|cinnamon|maple|bg reynolds/;

  function parseOz(amt) {
    if (!amt) return 0;
    var s = amt.toLowerCase();
    if (!/oz|ml\b|cl\b|dash|drop|tsp|barspoon|bar spoon|splash|scoop|cup/.test(s)) return 0;
    var oz = 0, frac = 0, m;
    for (var f in FRACTIONS) { if (s.indexOf(f) !== -1) { frac = FRACTIONS[f]; s = s.replace(f, ''); } }
    m = s.match(/(\d+(?:\.\d+)?)/);
    if (m) oz = parseFloat(m[1]);
    oz += frac;
    if (/dash|drop|tsp|barspoon|bar spoon|splash/.test(s)) oz = Math.min(oz || 1, 0.125);
    return oz;
  }

  function deriveFacets(ingLines) {
    var sour = 0, sweet = 0, spiritOz = 0, slugs = [];
    ingLines.forEach(function (l) {
      var nm = l.name, oz = l.oz;
      if (SPIRITS_RE.test(nm)) {
        spiritOz += oz;
        ['rum', 'gin', 'bourbon', 'rye', 'scotch', 'whisk', 'tequila', 'mezcal', 'vodka'].forEach(function (sp) {
          if (nm.indexOf(sp) !== -1) slugs.push(sp === 'whisk' ? 'whiskey' : sp);
        });
        return;
      }
      if (SHARP_RE.test(nm)) sour += oz;
      if (SWEET_RE.test(nm)) sweet += oz;
    });
    var r = sweet / Math.max(sour, 0.25);
    var sweetness = r >= 1.6 ? 5 : r >= 1.2 ? 4 : r >= 0.85 ? 3 : r >= 0.6 ? 2 : 1;
    var strength = spiritOz >= 3 ? 5 : spiritOz >= 2.25 ? 4 : spiritOz >= 1.5 ? 3 : spiritOz >= 0.75 ? 2 : 1;
    return { sweetness: sweetness, strength: strength, spirits: slugs, flavors: [], serve: [], pantry: [], syrups: [], category: '' };
  }

  /* ---------- card reconciliation ---------- */

  var submitBlock = book.querySelector('.so-recipe-submit');
  var template = book.querySelector('.so-recipe');

  function fillCard(sec, r) {
    sec.id = 'recipe-' + handleize(r.title);
    sec.classList.remove('so-recipe--suggested');
    var art = sec.querySelector('.so-recipe__card');
    if (art) art.setAttribute('data-drink-name', r.title);
    function setText(selector, val) {
      var el = sec.querySelector(selector);
      if (!el) return null;
      if (val) { el.textContent = val; return el; }
      // remove the element and, for rule-headed blocks, its rule
      el.remove();
      return null;
    }
    sec.querySelector('.so-recipe__name').textContent = r.title;
    setText('.so-recipe__lineage', r.lineage || '');
    // ingredients
    var ul = sec.querySelector('.so-recipe__ingredients');
    if (ul) {
      ul.innerHTML = '';
      (r.ingredients || '').split('\n').forEach(function (line) {
        var parts = line.split('|');
        if (parts.length < 2) return;
        var li = document.createElement('li');
        var nameSpan = document.createElement('span');
        nameSpan.textContent = parts[1].trim();
        if (parts[1].indexOf('BG Reynolds') !== -1) nameSpan.className = 'syrup';
        var amtSpan = document.createElement('span');
        amtSpan.className = 'amt';
        amtSpan.textContent = parts[0].trim();
        li.appendChild(nameSpan);
        li.appendChild(amtSpan);
        ul.appendChild(li);
      });
    }
    // Tag cards that call for rum so the page-level rum-guide link can show
    // only when a rum drink is visible (see updateRumLink).
    var callsRum = (r.ingredients || '').split('\n').some(function (line) {
      var p = line.split('|');
      if (p.length < 2) return false;
      var nm = p[1].trim().toLowerCase();
      return nm.indexOf('rum') !== -1 || nm.indexOf('rhum') !== -1;
    });
    sec.setAttribute('data-so-rum', callsRum ? '1' : '0');
    var methodEl = sec.querySelector('.so-recipe__method');
    if (methodEl) {
      if (r.method) methodEl.textContent = r.method;
      else { var mr = methodEl.previousElementSibling; if (mr && mr.classList.contains('so-recipe__rule')) mr.remove(); methodEl.remove(); }
    }
    var serveWrap = sec.querySelector('.so-recipe__serve');
    if (serveWrap) {
      var divs = serveWrap.querySelectorAll('div');
      var vals = [r.glass, r.garnish];
      Array.prototype.forEach.call(divs, function (d, i) {
        var span = d.querySelector('span');
        if (vals[i] && span) span.textContent = vals[i];
        else if (!vals[i]) d.remove();
      });
      if (!r.glass && !r.garnish) serveWrap.remove();
    }
    setText('.so-recipe__credit', r.credit || '');
    var fig = sec.querySelector('.so-recipe__photo');
    if (r.image) {
      if (fig) { var im = fig.querySelector('img'); im.src = r.image + (r.image.indexOf('?') !== -1 ? '&' : '?') + 'width=700'; im.alt = r.title; }
    } else if (fig) fig.remove();
    var bl = sec.querySelector('[data-so-batch-link]');
    if (bl) { bl.removeAttribute('data-so-wired'); bl.setAttribute('hidden', ''); }
    return sec;
  }

  function reconcile(recipes) {
    var byId = {};
    Array.prototype.forEach.call(book.querySelectorAll('.so-recipe'), function (sec) {
      if (sec.id) byId[sec.id] = sec;
    });
    var ordered = [];
    recipes.forEach(function (r) {
      var id = 'recipe-' + handleize(r.title);
      var sec = byId[id];
      if (!sec) {
        // Liquid uses Shopify's handleize (transliterates accents: Piña ->
        // pina); ours doesn't (pi-a). When the ids diverge we clone fresh
        // and normalize the id below, then the orphaned Liquid card is
        // removed so nothing renders twice.
        sec = template.cloneNode(true);
        fillCard(sec, r);
      } else {
        sec.id = id; // normalize to our handleize so links/anchors are consistent
      }
      ordered.push(sec);
      delete byId[id];
    });
    // remove any Liquid-rendered card that no active recipe claimed
    // (accent-handleize orphans, or a recipe that went draft) — no duplicates
    Object.keys(byId).forEach(function (k) {
      var el = byId[k];
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    // insert in sort order, before the submit block
    ordered.forEach(function (sec) { book.insertBefore(sec, submitBlock || null); });
    // place the "bar keeps a page open" CTA after the 10th recipe card
    var pageOpen = document.getElementById('so-bb-pageopen');
    if (pageOpen) {
      if (ordered.length > 10) { book.insertBefore(pageOpen, ordered[10]); }
      else { book.insertBefore(pageOpen, submitBlock || null); }
    }
    if (window.soWireBatchLinks) window.soWireBatchLinks(book);
    return ordered;
  }

  /* ---------- index ---------- */

  function buildIndex(recipes, secs) {
    return recipes.map(function (r, i) {
      var ingLines = (r.ingredients || '').split('\n').map(function (l) {
        var p = l.split('|');
        return { name: (p[1] || '').trim().toLowerCase(), oz: parseOz((p[0] || '').trim()) };
      }).filter(function (l) { return l.name; });
      var curated = typeof r.sweetness === 'number' && r.sweetness > 0;
      var f = curated
        ? { sweetness: r.sweetness, strength: r.strength, spirits: r.spirits || [], flavors: r.flavors || [], serve: r.serve || [], pantry: r.pantry || [], syrups: r.syrups || [], category: r.category || '' }
        : deriveFacets(ingLines);
      var slugText = (f.spirits.concat(f.pantry, f.syrups, f.flavors, f.serve, [f.category])).join(' ').replace(/-/g, ' ');
      return {
        el: secs[i],
        name: r.title,
        text: (r.title + ' ' + (r.lineage || '') + ' ' + ingLines.map(function (l) { return l.name; }).join(' ') + ' ' + (r.method || '') + ' ' + slugText).toLowerCase(),
        count: ingLines.length,
        sweetness: f.sweetness,
        strength: f.strength,
        spirits: f.spirits,
        flavors: f.flavors,
        serve: f.serve,
        pantry: f.pantry,
        syrups: f.syrups,
        category: f.category || ''
      };
    });
  }

  /* ---------- scoring (contract phrase mappings) ---------- */

  var INTENTS = [
    { re: /tart|sour(?!ce)|tangy|zippy|\bdry\b|puckery/, score: function (c) {
        if (c.serve.indexOf('hot') !== -1) return 0;
        var s = c.sweetness <= 2 ? (3 - c.sweetness) * 3 : 0;
        if (c.flavors.indexOf('tart') !== -1) s += 2;
        return s;
      } },
    { re: /not too sweet|semi.?sweet|balanced/, score: function (c) { return c.sweetness <= 3 ? 3 : 0; } },
    { re: /sweet|dessert|candy/, score: function (c) {
        var s = c.sweetness >= 4 ? (c.sweetness - 3) * 3 : 0;
        if (c.flavors.indexOf('sweet') !== -1) s += 1;
        return s;
      } },
    { re: /won'?t taste|can'?t taste|don'?t taste|easy.?going|easy drinking|smooth|gentle|light on the/, score: function (c) {
        // "won't taste the alcohol" implies alcohol IS present, just hidden —
        // zero-proof (strength 1) has nothing to hide and doesn't qualify.
        // Gentle drinks (2) qualify; sweetness-masked moderates too (the
        // Painkiller clause: sweetness 5 / strength 3 is the canonical answer).
        if (c.strength === 1) return 0;
        if (c.strength === 2) return 4;
        if (c.strength === 3 && c.sweetness >= 4) return 4 + (c.sweetness >= 5 ? 2 : 0);
        return 0;
      } },
    { re: /stiff|strong|boozy|potent|spirit.?forward|dangerous|knock/, score: function (c) {
        var s = c.strength >= 4 ? (c.strength - 3) * 3 : 0;
        if (c.flavors.indexOf('strong') !== -1) s += 1;
        return s;
      } },
    { re: /zero.?proof|no (booze|alcohol)|non.?alcoholic|mocktail|sober|virgin/, score: function (c) {
        return (c.strength === 1 ? 8 : 0) + (c.category === 'zero-proof' ? 3 : 0);
      } },
    { re: /easy|simple|quick|few ingredients|beginner/, score: function (c) { return c.count <= 4 ? 4 : c.count <= 5 ? 2 : 0; } },
    { re: /classic|vintage|old.?school|traditional|authentic|history/, score: function (c) { return c.category.indexOf('classic') === 0 ? 4 : 0; } },
    { re: /spicy|spiced/, score: function (c) { return (c.flavors.indexOf('spicy') !== -1 ? 4 : 0); } },
    { re: /hot\b|toddy|fireplace|cold night|rainy|winter|warm me/, score: function (c) { return c.serve.indexOf('hot') !== -1 ? 6 : (c.category === 'warm' ? 4 : 0); } },
    { re: /refreshing|crushable|summer|thirst|tall|cooler/, score: function (c) {
        return (c.serve.indexOf('tall') !== -1 || c.serve.indexOf('swizzled') !== -1 ? 3 : 0) + (c.strength <= 3 ? 1 : 0);
      } },
    { re: /blended|frozen|slush/, score: function (c) { return c.serve.indexOf('blended') !== -1 ? 6 : 0; } },
    { re: /party|crowd|batch|punch bowl|guests|group/, score: function (c) { return c.serve.indexOf('group') !== -1 ? 5 : (/punch|bowl/.test(c.text) ? 2 : 0); } },
    { re: /fruity|tropical|juicy/, score: function (c) { return (c.flavors.indexOf('tropical') !== -1 ? 4 : 0) + (/pineapple|passion|mango|guava|banana/.test(c.text) ? 1 : 0); } },
    { re: /creamy|rich|silky|velvet/, score: function (c) { return (c.flavors.indexOf('creamy') !== -1 ? 4 : 0); } }
  ];

  var SPIRIT_ASKS = [
    { re: /\brum(my|mie)?s?\b|cachaca|cachaça/, test: function (sl) { return /rum|cachaca|arrack/.test(sl); } },
    { re: /\bgin(ny)?\b|genever/, test: function (sl) { return /gin|genever/.test(sl); } },
    { re: /whisk|bourbon|rye\b|scotch/, test: function (sl) { return /bourbon|rye|scotch|whiskey/.test(sl); } },
    { re: /tequila|mezcal|agave/, test: function (sl) { return /tequila/.test(sl); } },
    { re: /vodka/, test: function (sl) { return /vodka/.test(sl); } }
  ];

  var STOP = /^(a|an|the|i|i'm|im|me|my|want|wanna|like|something|somethin|drink|cocktail|with|and|or|for|of|to|have|has|got|on|hand|in|make|made|please|feel|feeling|tonight|some|that|whats|what's|good|really|very)$/;

  function ask(cards, query) {
    var q = query.toLowerCase();
    var tokens = q.split(/[^a-z0-9']+/).filter(function (t) { return t && !STOP.test(t) && t.length > 2; });
    var gates = SPIRIT_ASKS.filter(function (sa) { return sa.re.test(q); });
    var results = cards.map(function (c) {
      var s = 0;
      INTENTS.forEach(function (intent) { if (intent.re.test(q)) s += intent.score(c); });
      tokens.forEach(function (t) {
        if (c.name.toLowerCase().indexOf(t) !== -1) s += 6;
        else if (c.text.indexOf(t) !== -1) s += 2;
      });
      if (gates.length) {
        var slugStr = c.spirits.join(' ');
        var hit = gates.some(function (g) { return g.test(slugStr); });
        if (hit) s += 4; else s *= 0.25;
      }
      return { c: c, s: s, r: Math.random() };
    }).filter(function (r) { return r.s > 1; });
    // ties shuffle: 17 drinks can legitimately tie on a facet ask — a random
    // tie-break means repeat asks surface variety, like a barkeep's mood
    results.sort(function (a, b) { return (b.s - a.s) || (b.r - a.r); });
    if (!results.length) return [];
    // relevance floor: keep genuine matches (>= 40% of the top score) so a
    // vague ask returns a browsable set, not the whole book; hard cap at 30.
    var floor = Math.max(1.5, results[0].s * 0.4);
    return results.filter(function (r) { return r.s >= floor; }).slice(0, 30).map(function (r) { return r.c; });
  }

  /* ---------- UI wiring ---------- */

  function wire(cards) {
    var input = finder.querySelector('#soBBAsk');
    var goBtn = finder.querySelector('#soBBGo');
    var chips = finder.querySelectorAll('[data-bb-chip]');
    var results = finder.querySelector('#soBBResults');
    var countEl = finder.querySelector('#soBBCount');

    var origOrder = cards.map(function (c) { return c.el; });

    function setChipActive(kind) {
      Array.prototype.forEach.call(chips, function (c) {
        c.classList.toggle('so-bb-finder__chip--on', c.getAttribute('data-bb-chip') === kind);
      });
    }
    // put every card back in its canonical sort order (before the submit block)
    function restoreOrder() {
      origOrder.forEach(function (el) { book.insertBefore(el, submitBlock || null); });
    }
    function showAllCards() {
      cards.forEach(function (c) { c.el.style.display = ''; });
    }
    function reset() {
      restoreOrder();
      showAllCards();
      results.hidden = true;
      results.innerHTML = '';
      if (countEl) countEl.textContent = '';
      setChipActive('all');
    }

    // wire the click handlers inside a freshly-rendered results box
    function wireResultLinks() {
      Array.prototype.forEach.call(results.querySelectorAll('a[href^="#"]:not([data-bb-reset])'), function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var t = document.getElementById(a.getAttribute('href').slice(1));
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
      var resetLink = results.querySelector('[data-bb-reset]');
      if (resetLink) resetLink.addEventListener('click', function (e) { e.preventDefault(); if (input) input.value = ''; reset(); });
    }

    // filter the grid to ONLY the given cards, in the given order, directly
    // below the finder; no auto-scroll. Shared by search + pantry.
    function applyPicks(ordered, boxHtml) {
      var matched = {};
      ordered.forEach(function (c) { matched[c.el.id] = true; });
      cards.forEach(function (c) { c.el.style.display = matched[c.el.id] ? '' : 'none'; });
      var anchor = finder;
      ordered.forEach(function (c) { book.insertBefore(c.el, anchor.nextSibling); anchor = c.el; });
      results.innerHTML = boxHtml;
      results.hidden = false;
      if (countEl) countEl.textContent = '';
      setChipActive(null);
      wireResultLinks();
    }

    function showResults(picks, query) {
      if (!picks.length) {
        restoreOrder();
        showAllCards();
        results.innerHTML =
          '<p class="so-bb-finder__verdict">The Bar Book holds no answer for &ldquo;' +
          query.replace(/</g, '&lt;').slice(0, 60) + '&rdquo;.</p>' +
          '<p class="so-bb-finder__oracle">This calls for higher powers: <a href="/pages/the-syrups-oracle">consult the Oracle</a>.</p>';
        results.hidden = false;
        if (countEl) countEl.textContent = '';
        return;
      }
      var links = picks.map(function (c) {
        return '<li><a href="#' + c.el.id + '">' + c.name + '</a></li>';
      }).join('');
      applyPicks(picks,
        '<p class="so-bb-finder__verdict">' + picks.length + (picks.length === 1 ? ' spec' : ' specs') + ' &mdash; closest first:</p>' +
        '<ul>' + links + '</ul>' +
        '<p class="so-bb-finder__reset"><a href="#" data-bb-reset>&larr; Show all ' + cards.length + ' recipes</a></p>' +
        '<p class="so-bb-finder__oracle">Not quite it? <a href="/pages/the-syrups-oracle">Consult the Oracle</a> &mdash; it deals in drinks that don’t exist yet.</p>');
    }

    /* ---------- pantry: "what can I make with what's on hand" ---------- */
    function setupPantry() {
      var toggle = document.getElementById('soBBPantryToggle');
      var panel = document.getElementById('soBBPantry');
      var groupsWrap = document.getElementById('soBBPantryGroups');
      var goBtn2 = document.getElementById('soBBPantryGo');
      var clearBtn = document.getElementById('soBBPantryClear');
      if (!toggle || !panel || !groupsWrap || !goBtn2) return;

      var freq = { spirits: {}, syrups: {}, pantry: {} };
      cards.forEach(function (c) {
        ['spirits', 'syrups', 'pantry'].forEach(function (g) {
          (c[g] || []).forEach(function (slug) { if (slug) freq[g][slug] = (freq[g][slug] || 0) + 1; });
        });
      });
      function slugsSorted(g) {
        return Object.keys(freq[g]).sort(function (a, b) { return freq[g][b] - freq[g][a] || a.localeCompare(b); });
      }
      var GROUPS = [
        { key: 'spirits', label: 'Spirits & liqueurs' },
        { key: 'syrups', label: 'BG Reynolds syrups' },
        { key: 'pantry', label: 'Juices, mixers & pantry' }
      ];
      var html = '';
      GROUPS.forEach(function (g) {
        var slugs = slugsSorted(g.key);
        if (!slugs.length) return;
        html += '<fieldset class="so-bb-pantry__group"><legend>' + g.label + '</legend><div class="so-bb-pantry__checks">';
        slugs.forEach(function (slug) {
          html += '<label class="so-bb-pantry__check"><input type="checkbox" value="' + slug + '"><span>' + prettySlug(slug) + '</span></label>';
        });
        html += '</div></fieldset>';
      });
      groupsWrap.innerHTML = html;

      toggle.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      function ownedSet() {
        var s = {};
        Array.prototype.forEach.call(groupsWrap.querySelectorAll('input:checked'), function (cb) { s[cb.value] = true; });
        return s;
      }

      function compute() {
        var owned = ownedSet();
        var makeable = [], almost = [];
        cards.forEach(function (c) {
          var need = {};
          (c.spirits || []).concat(c.syrups || [], c.pantry || []).forEach(function (s) { if (s) need[s] = true; });
          var needArr = Object.keys(need);
          if (!needArr.length) return; // untagged — can't reason about it
          var missing = needArr.filter(function (s) { return !owned[s]; });
          var missBottles = (c.spirits || []).concat(c.syrups || []).filter(function (s) { return !owned[s]; });
          if (!missing.length) makeable.push(c);
          else if (!missBottles.length && missing.length <= 2) almost.push({ c: c, missing: missing });
        });
        makeable.sort(function (a, b) { return a.count - b.count || a.name.localeCompare(b.name); });
        almost.sort(function (a, b) { return a.missing.length - b.missing.length || a.c.count - b.c.count; });
        return { owned: owned, makeable: makeable, almost: almost };
      }

      function runPantry() {
        var r = compute();
        if (!Object.keys(r.owned).length) {
          results.innerHTML = '<p class="so-bb-finder__verdict">Check a few things you have, and I&rsquo;ll tell you what to pour.</p>';
          results.hidden = false;
          return;
        }
        if (!r.makeable.length && !r.almost.length) {
          cards.forEach(function (c) { c.el.style.display = 'none'; });
          restoreOrder();
          results.innerHTML =
            '<p class="so-bb-finder__verdict">Nothing in the book fits that shelf yet.</p>' +
            '<p class="so-bb-finder__reset"><a href="#" data-bb-reset>&larr; Show all ' + cards.length + ' recipes</a></p>' +
            '<p class="so-bb-finder__oracle">Check a spirit or two more &mdash; or <a href="/pages/the-syrups-oracle">consult the Oracle</a>.</p>';
          results.hidden = false;
          wireResultLinks();
          return;
        }
        var ordered = r.makeable.concat(r.almost.map(function (a) { return a.c; }));
        var box = r.makeable.length
          ? '<p class="so-bb-finder__verdict">You can pour ' + r.makeable.length + ' right now' +
            (r.almost.length ? ', and ' + r.almost.length + ' more with a quick trip' : '') + ':</p>'
          : '<p class="so-bb-finder__verdict">Nothing pours as-is quite yet &mdash; but ' + r.almost.length +
            (r.almost.length === 1 ? ' drink is' : ' drinks are') + ' one quick trip away:</p>';
        if (r.makeable.length) {
          box += '<ul>' + r.makeable.map(function (c) { return '<li><a href="#' + c.el.id + '">' + c.name + '</a></li>'; }).join('') + '</ul>';
        }
        if (r.almost.length) {
          box += '<p class="so-bb-pantry__almost-head">One trip away:</p><ul class="so-bb-pantry__almost">' +
            r.almost.map(function (a) {
              return '<li><a href="#' + a.c.el.id + '">' + a.c.name + '</a> <span class="so-bb-pantry__grab">grab ' + a.missing.map(prettySlug).join(', ') + '</span></li>';
            }).join('') + '</ul>';
        }
        box += '<p class="so-bb-finder__reset"><a href="#" data-bb-reset>&larr; Show all ' + cards.length + ' recipes</a></p>';
        box += '<p class="so-bb-finder__oracle">Nothing sings? <a href="/pages/the-syrups-oracle">Consult the Oracle</a>.</p>';
        applyPicks(ordered, box);
      }

      goBtn2.addEventListener('click', runPantry);
      if (clearBtn) clearBtn.addEventListener('click', function () {
        Array.prototype.forEach.call(groupsWrap.querySelectorAll('input:checked'), function (cb) {
          cb.checked = false;
          var l = cb.closest('.so-bb-pantry__check');
          if (l) l.classList.remove('so-bb-pantry__check--on');
        });
        updateLive();
        reset();
      });

      // live tally in the toggle-ish area, no card reflow
      var live = document.createElement('span');
      live.className = 'so-bb-pantry__live';
      goBtn2.parentNode.insertBefore(live, goBtn2.nextSibling);
      function updateLive() {
        var n = Object.keys(ownedSet()).length;
        if (!n) { live.textContent = ''; return; }
        live.textContent = compute().makeable.length + ' pourable';
      }
      groupsWrap.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'checkbox') {
          var l = e.target.closest('.so-bb-pantry__check');
          if (l) l.classList.toggle('so-bb-pantry__check--on', e.target.checked);
        }
        updateLive();
      });

      /* deep-link support: ?have= tokens arrive as facet slugs OR BG Reynolds
         product handles (marketing emails link "what can I make with what I
         just bought"). Resolve each to a checkbox slug — exact, then the
         irregular-handle map, then progressive suffix stripping — tick the
         matches, open the panel, run. Unknown tokens are ignored. */
      var HANDLE_SLUGS = {
        'original-orgeat-tropical-syrup': 'orgeat',
        'divine-vanilla': 'vanilla',
        'red-fassionola': 'fassionola',
        'orange-blossom-honey-mix': 'honey-mix',
        'devils-reef-pineapple-molasses-syrup': 'pineapple-molasses',
        'severed-santa-edition-hot-buttered-rum-syrup': 'hot-buttered-rum'
      };
      var allSlugs = {};
      ['spirits', 'syrups', 'pantry'].forEach(function (g) {
        Object.keys(freq[g]).forEach(function (s) { allSlugs[s] = true; });
      });
      function resolveToken(tok) {
        tok = (tok || '').trim().toLowerCase();
        if (!tok) return null;
        if (allSlugs[tok]) return tok;
        var mapped = HANDLE_SLUGS[tok];
        if (mapped && allSlugs[mapped]) return mapped;
        var t = tok.replace(/-(tropical-)?(cocktail-)?syrup$/, '');
        if (allSlugs[t]) return t;
        t = t.replace(/-(750|375)ml$/, '');
        if (allSlugs[t]) return t;
        t = t.replace(/-mix$/, '');
        if (allSlugs[t]) return t;
        return null;
      }
      function applyHave(tokens) {
        var hits = 0;
        tokens.forEach(function (tok) {
          var slug = resolveToken(tok);
          if (!slug) return;
          var cb = groupsWrap.querySelector('input[value="' + slug + '"]');
          if (cb && !cb.checked) {
            cb.checked = true;
            var l = cb.closest('.so-bb-pantry__check');
            if (l) l.classList.add('so-bb-pantry__check--on');
            hits++;
          }
        });
        if (!hits) return false;
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        updateLive();
        runPantry();
        return true;
      }
      return { applyHave: applyHave };
    }

    function runAsk() {
      var q = (input.value || '').trim();
      if (!q) { reset(); return; }
      showResults(ask(cards, q), q);
    }
    goBtn.addEventListener('click', runAsk);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); runAsk(); } });

    function applyChip(kind) {
      restoreOrder();
      results.hidden = true;
      results.innerHTML = '';
      var shown = 0;
      cards.forEach(function (c) {
        var ok = true;
        var sl = c.spirits.join(' ');
        if (kind === 'rum') ok = /rum|cachaca|arrack/.test(sl);
        else if (kind === 'gin') ok = /gin|genever/.test(sl);
        else if (kind === 'whisk') ok = /bourbon|rye|scotch|whiskey/.test(sl);
        else if (kind === 'tequila') ok = /tequila/.test(sl);
        else if (kind === 'easy') ok = c.count <= 5;
        else if (kind === 'classic') ok = c.category.indexOf('classic') === 0;
        else if (kind === 'zeroproof') ok = c.strength === 1 || c.category === 'zero-proof';
        c.el.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = kind === 'all' ? '' : 'Showing ' + shown + ' of ' + cards.length + ' specs';
    }
    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () {
        input.value = '';
        setChipActive(chip.getAttribute('data-bb-chip'));
        applyChip(chip.getAttribute('data-bb-chip'));
      });
    });

    var pantryApi = setupPantry();
    finder.hidden = false;

    // Page-level rum-guide link: low-key, beneath the finder, shown only when
    // a rum drink is currently visible on the page (respects chip/search/pantry
    // filtering). Replaces the per-card tips in the Bar Book.
    var rumLink = document.getElementById('soBBRumLink');
    function updateRumLink() {
      if (!rumLink) return;
      var anyVisible = Array.prototype.some.call(
        book.querySelectorAll('.so-recipe[data-so-rum="1"]'),
        function (el) { return el.style.display !== 'none'; }
      );
      rumLink.hidden = !anyVisible;
    }
    if (rumLink && window.MutationObserver) {
      var rumT;
      new MutationObserver(function () {
        clearTimeout(rumT); rumT = setTimeout(updateRumLink, 60);
      }).observe(book, { attributes: true, attributeFilter: ['style'], subtree: true });
    }
    updateRumLink();

    // Deep links (marketing emails, homepage cards): ?have=<tokens> pre-checks
    // the pantry and runs it; ?ask=<text> prefills the ask box and runs.
    // `have` wins when both are present. Unresolvable links leave the normal
    // Bar Book — graceful degrade is the contract.
    try {
      var qs = new URLSearchParams(window.location.search);
      var haveQ = qs.get('have');
      var askQ = qs.get('ask');
      var deepLinked = false;
      if (haveQ && pantryApi && pantryApi.applyHave(haveQ.split(','))) {
        deepLinked = true;
      } else if (askQ && askQ.trim()) {
        input.value = askQ.trim();
        runAsk();
        deepLinked = true;
      }
      if (deepLinked) {
        setTimeout(function () { finder.scrollIntoView({ behavior: 'auto', block: 'start' }); }, 150);
      }
    } catch (e) { /* no URLSearchParams: the page works, just without deep links */ }

    window.__soBB = { cards: cards, ask: function (q) { return ask(cards, q); } };
  }

  /* ---------- boot ---------- */

  function bootFromDom() {
    // fetch failed: index whatever Liquid rendered, deriving facets from ounces
    var secs = Array.prototype.slice.call(book.querySelectorAll('.so-recipe'));
    var recipes = secs.map(function (sec) {
      var ings = Array.prototype.map.call(sec.querySelectorAll('.so-recipe__ingredients li'), function (li) {
        var nm = li.querySelector('span') ? li.querySelector('span').textContent.trim() : '';
        var amt = li.querySelector('.amt') ? li.querySelector('.amt').textContent.trim() : '';
        return amt + ' | ' + nm;
      }).join('\n');
      return {
        title: (sec.querySelector('.so-recipe__name') || {}).textContent || '',
        lineage: (sec.querySelector('.so-recipe__lineage') || {}).textContent || '',
        ingredients: ings,
        method: (sec.querySelector('.so-recipe__method') || {}).textContent || '',
        sweetness: 0
      };
    });
    wire(buildIndex(recipes, secs));
  }

  // 10-minute cache-bust bucket. MUST be the ?v= param: Shopify's Files CDN
  // keys its cache per ?v value and ignores other query strings — so a given
  // ?v serves whatever was first fetched under it (dashboard regen surfaces
  // when the bucket rolls). 10-min bounds edit->storefront staleness.
  var cb = Math.floor(Date.now() / 600000);
  fetch(DATA_URL + (DATA_URL.indexOf('?') !== -1 ? '&' : '?') + 'v=' + cb)
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (doc) {
      var recipes = (doc.recipes || []).slice().sort(function (a, b) { return (a.sort || 9999) - (b.sort || 9999); });
      if (!recipes.length) throw new Error('empty');
      var secs = reconcile(recipes);
      wire(buildIndex(recipes, secs));
      try { sessionStorage.setItem('so-bb-names-v1', JSON.stringify({ t: Date.now(), names: recipes.map(function (r) { return r.title; }) })); } catch (e) {}
    })
    .catch(bootFromDom);
})();
